<template>
  <div class="flex flex-col font-primary min-h-screen text-muted">
    <!-- Desktop chrome -->
    <div class="hidden lg:block">
      <NavigationTopbar />
    </div>
    <!-- Mobile chrome (top) -->
    <MobileTopbar />

    <div class="flex px-4 lg:px-8 pb-28 lg:pb-16 mt-4 lg:mt-10">
      <!-- Desktop sidebar -->
      <div class="hidden lg:block w-56 flex-none">
        <NavigationBar />
      </div>
      <!-- main content -->
      <main id="main" class="flex-1 min-w-0 lg:pl-10">
        <router-view />
      </main>
    </div>

    <!-- Mobile chrome (bottom tabs) -->
    <MobileTabBar />

    <!-- First-login genre picker (seeds recommendations). -->
    <GenreOnboarding v-if="showOnboarding" @done="dismissed = true" />
  </div>
</template>

<script>
import NavigationBar from "@/components/navigation/NavigationBar.vue";
import NavigationTopbar from "@/components/navigation/NavigationTopbar.vue";
import MobileTopbar from "@/components/navigation/MobileTopbar.vue";
import MobileTabBar from "@/components/navigation/MobileTabBar.vue";
import GenreOnboarding from "@/components/series/GenreOnboarding.vue";

export default {
  name: "Authenticated",
  components: {
    NavigationBar,
    NavigationTopbar,
    MobileTopbar,
    MobileTabBar,
    GenreOnboarding,
  },

  data() {
    return {
      dismissed: false,
    };
  },

  computed: {
    // Show the picker once for users who have never chosen genres (null),
    // never for those who saved or skipped (which stores an array).
    showOnboarding() {
      const user = this.$store.getters.authUser;
      return !this.dismissed && !!user && user.genres == null;
    },
  },
};
</script>
